module.exports = __webpack_public_path__ + "static/media/alur.a6f468f2.jpeg";